const ROLES_AR = {
  admin: "مسؤول",
  companion: "مرافق",
  comptable: "محاسب",
  gestionnaire: "مدير",
  manager: "مدير",
  membre: "عضو",
  operative: "عامل",
} as const;

export default ROLES_AR;
